import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 学习报告
 */
export default [
  // 学习报告
  route('/learningReport', 'learningReport', component('learningReport/index'))
]
